export default "__VITE_ASSET__BLfHYK3A__"